module.exports = "../fonts/PTS75F.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/PTS75F.ttf
// module id = 581
// module chunks = 0